import { io } from "socket.io-client";
import {
  websocketConnected,
  websocketDisconnected,
  websocketError,
  websocketMessageReceived,
  setRooms,
} from "../slices/websocket";

let socket;

const websocketMiddleware = (store) => (next) => (action) => {
  if (action.type === "websocket/connect") {
    if (socket) {
      socket.close();
    }

    // Connect to Socket.IO server
    // action.payload should be the base URL (e.g. "http://localhost:3000")
    socket = io(action.payload, {
      transports: ["websocket"],
      // withCredentials: true, // Uncomment if you need to send cookies/session
    });

    socket.on("connect", () => {
      store.dispatch(websocketConnected());

      // Authenticate the user after connection
      // Get user data from sessionStorage or Redux store
      const token = sessionStorage.getItem("token");
      const nome = sessionStorage.getItem("nome");
      const roomsName = sessionStorage.getItem("roomsName");
      console.log(roomsName);
      let userId = null;

      if (roomsName) {
        userId = roomsName.split(",")[0];
      }

      if (token && nome && userId) {
        try {
          /* userId =
            nome === "Riccardo"
              ? "2B3DA454-3F5A-4145-B773-B89B12B7E579"
              : "7BEB1065-30D3-4CDE-8A1C-940B7433DD2B"; */

          // Send authentication to server with rooms
          socket.emit("authenticate", {
            userId,
            roomsName,
          });
          console.log(
            `Authenticating socket for user: ${userId} -- ${nome} with rooms:`,
            roomsName
          );
        } catch (error) {
          console.error(
            "Error parsing user data for socket authentication:",
            error
          );
        }
      }
    });

    socket.on("disconnect", () => {
      store.dispatch(websocketDisconnected());
    });

    socket.on("connect_error", (error) => {
      store.dispatch(websocketError(error.message));
    });

    // Listen for authentication confirmation
    socket.on("authenticated", (data) => {
      if (data.success) {
        console.log("Socket authenticated successfully:", data.message);

        // Handle rooms that come from the server (e.g., user groups, departments)
        // If the server doesn't return rooms yet, we use example rooms
        const userRooms = data.roomsName;
        store.dispatch(setRooms(userRooms));
        console.log("Rooms joined:", userRooms);
      } else {
        console.error("Socket authentication failed:", data.message);
      }
    });

    // Listen for "avvisi:new" event specifically
    socket.on("avvisi:new", (payload) => {
      // Use "payload" as variable name to avoid confusion with internal "data" property
      if (payload && payload.data) {
        store.dispatch(
          websocketMessageReceived({
            type: "avvisi:new",
            data: payload.data,
          })
        );

        // Show snackbar for the incoming notification
        const { showSnackbar } = require("../slices/snackbar");
        store.dispatch(
          showSnackbar({
            message: `Nuova comunicazione: ${
              payload.data.titolo || payload.data.Titolo || "Ricevuto"
            }`,
            severity: payload.data.idTipologia == 2 ? "warning" : "info",
          })
        );
      }
    });

    // Listen for generic messages if used
    socket.on("message", (data) => {
      store.dispatch(websocketMessageReceived(data));
    });
  }

  if (action.type === "websocket/send") {
    if (socket) {
      // Assuming payload has { type, data } or similar if using generic emit
      // For specific events, you might need to adjust this.
      // Example: store.dispatch({ type: 'websocket/send', payload: { event: 'chat', data: 'hello' } })
      if (action.payload.event) {
        socket.emit(action.payload.event, action.payload.data);
      } else {
        socket.emit("message", action.payload);
      }
    }
  }

  if (action.type === "websocket/disconnect") {
    if (socket) {
      socket.disconnect();
    }
  }

  return next(action);
};

export default websocketMiddleware;
